import { handleActions } from 'redux-actions';
import { ErrorsState } from './interfaces';
import Types from './types';

const initialState: ErrorsState = {
  fieldsErrors: null,
};

export default handleActions(
  {
    [Types.GET_ERRORS_REQUEST]: (state: ErrorsState) => ({
      ...state,
      fieldsErrors: null,
    }),
    [Types.GET_ERRORS_FULFILLED]: (state: ErrorsState, { payload }) => ({
      ...state,
      fieldsErrors: payload.error,
    }),
    [Types.CLEAR_FIELDS_REQUEST]: (state: ErrorsState) => ({
      ...state,
      fieldsErrors: null,
    }),
    [Types.CLEAR_FIELDS_FULFILLED]: (state: ErrorsState) => ({
      ...state,
      fieldsErrors: null,
    }),
  },
  initialState
);
